import React from 'react'
import colors from '../colors'

export default function Button ({
  children,
  borderColor = colors.green,
  fillBackground = false,
  className = '',
  style = {},
  ...props
}) {
  return (
    <button
      className={`button button${borderColor} ${className}`}
      style={{
        ...style,
        backgroundColor: fillBackground ? 'var(--black)' : '',
        border: `4px solid var(${borderColor})`
      }}
      {...props}
    >
      {children}
    </button>
  )
}
